import React from "react";
import { Container } from "react-bootstrap";
import "./Eight.css";
import frem1 from "../../../../Asset/d2c/Frame-290559.png";
import frem2 from "../../../../Asset/d2c/Frame-290560.png";
import frem3 from "../../../../Asset/d2c/Frame-1000004409.png";
import frem4 from "../../../../Asset/d2c/Frame-1000004411.png";
import frem5 from "../../../../Asset/d2c/Frame-1000004413.png";
import frem6 from "../../../../Asset/d2c/Frame-1000004412.png";

const Eight = () => {
  return (
    <>
      <section className="eight-d2c-section">
        <Container>
          <div className="text_wrap">
            <h2>
              We Ensure your <strong> Store's Success</strong>
            </h2>
            <p className="store-success-intro">
              We don't just build your D2C store; we become your dedicated
              growth partner.
            </p>
            <p className="store-success-text">
              Our comprehensive approach includes implementing features that
              boost performance, crafting customer engagement strategies, and
              establishing roadmap for sustainable growth.
            </p>
          </div>
          <div className="models_cards_warp">
            <div className="row models_row">
              <div className="col-xl-4 col-lg-4 col-md-6 col-sm-12">
                <div className="models_boxs">
                  <div className="image_part mb-3">
                    <img src={frem1} alt="box" className="w-100" />
                  </div>
                  <div className="content_part">
                    <h3>Consultation & D2C eCommerce Strategy</h3>
                    <p>
                      We start with understanding your goals and market
                      opportunities. We help you define a clear roadmap for your
                      store’s success, focusing on target audience analysis,
                      competitor research, and market trends.
                    </p>
                  </div>
                </div>
              </div>
              <div className="col-xl-4 col-lg-4 col-md-6 col-sm-12">
                <div className="models_boxs">
                  <div className="image_part mb-3">
                    <img src={frem2} alt="box" className="w-100" />
                  </div>
                  <div className="content_part">
                    <h3>User Journey Mapping</h3>
                    <p>
                      We design and optimize the customer journey from landing
                      page to checkout, ensuring a smooth and intuitive shopping
                      experience. Easily engage your customers with personalized
                      product recommendations and targeted promotions, based on
                      their buying behavior. We focus on continuously refining
                      the user experience across all touchpoints to enhance
                      customer satisfaction, brand loyalty, and boost
                      conversion.
                    </p>
                  </div>
                </div>
              </div>
              <div className="col-xl-4 col-lg-4 col-md-6 col-sm-12">
                <div className="models_boxs">
                  <div className="image_part mb-3">
                    <img src={frem3} alt="box" className="w-100" />
                  </div>
                  <div className="content_part">
                    <h3>Responsive Theme Design: UI/UX Excellence</h3>
                    <p>
                      Our design team creates visually stunning and responsive
                      themes that offer an intuitive user experience across all
                      devices. We focus on crafting a user-friendly interface
                      that is easy to navigate and boost customer engagement.
                    </p>
                  </div>
                </div>
              </div>
              <div className="col-xl-4 col-lg-4 col-md-6 col-sm-12">
                <div className="models_boxs">
                  <div className="image_part mb-3">
                    <img src={frem4} alt="box" className="w-100" />
                  </div>
                  <div className="content_part">
                    <h3>Data-driven Analytics & Insights</h3>
                    <p>
                      We set up dynamic dashboards that track crucial key
                      performance indicators (KPIs) in real-time, that
                      transforms raw data into business insights. Our automated
                      reports delve into sales trends, customer behaviour, and
                      inventory management, that give you insights to take
                      important business decisions. This data-driven approach
                      empowers you to continuously refine your D2C strategy and
                      fuel your business growth.
                    </p>
                  </div>
                </div>
              </div>
              <div className="col-xl-4 col-lg-4 col-md-6 col-sm-12">
                <div className="models_boxs">
                  <div className="image_part mb-3">
                    <img src={frem5} alt="box" className="w-100" />
                  </div>
                  <div className="content_part">
                    <h3>Customer Loyalty and Engagement Strategy</h3>
                    <p>
                      As India's leading D2C eCommerce service providers, we not
                      only help you build your online store but also implement
                      robust loyalty and engagement strategies. These strategies
                      are designed to strengthen customer relationships, build a
                      loyal customer base, enhance brand trust, and ultimately
                      increase returning customers and revenue.
                    </p>
                  </div>
                </div>
              </div>
              <div className="col-xl-4 col-lg-4 col-md-6 col-sm-12">
                <div className="models_boxs">
                  <div className="image_part mb-3">
                    <img src={frem6} alt="box" className="w-100" />
                  </div>
                  <div className="content_part">
                    <h3>Consultation & D2C eCommerce Strategy</h3>
                    <p>
                      We provide a dedicated "Account Manager" for our D2C
                      brands, focusing on technical assistance and implementing
                      features that enhance customer experience. Your Account
                      Manager oversees the integration of new plugins and
                      essential APIs, ensuring your D2C store functions smoothly
                      and efficiently at all times.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </Container>
      </section>
    </>
  );
};

export default Eight;
